// Base
import Image from 'next/image'

// Helpers
import { useMediaQuery } from '@helpers/useMediaQuery'

// Components
import { Column, Container, Row } from '@components/app/Layout'
import Text from '@components/helpers/text/Text'
import { Button } from '@components/common/button/Buttons'
import Box from '@components/helpers/box/Box'
import Flex from '@components/helpers/flex/Flex'

// Images
import Hero from 'public/images/photos/homepage-hero.png'

// Styles
import styles from './Homepage.module.sass'

const Homepage = () => {
  return (
    <section className={styles.homepage}>
      <Image
        src={Hero}
        fill
        placeholder="blur"
        sizes="
          (min-width: 1120px) 1120px,
          375px
        "
        alt="Beach"
      />
      <Container>
        <div className={styles.homepage__wrapper}>
          <Flex center flexDirection="column" rowGap={{ sm: 32, lg: 48 }}>
            <SocialProof />

            <Text tagName="h1" variant="title-2" align="center" color="white">
              Dive into the{' '}
              <Text tagName="span" variant="title-2" color="yellow">
                world
              </Text>{' '}
              of cheap travel
            </Text>
          </Flex>

          <Row position="center">
            <Column column={4} gutter={6}>
              <Button href="/destinations" variant="button-1">
                Sign Up for FREE
              </Button>
            </Column>
          </Row>
        </div>
      </Container>
    </section>
  )
}

const SocialProof = () => {
  const isDesktop = useMediaQuery(1168)

  return (
    <Box
      padding={{ sm: [4, 16], lg: [8, 32] }}
      borderRadius={{ sm: [36] }}
      className={styles.homepage__socialProof}
    >
      <Flex center columnGap={{ sm: 16 }}>
        <Image
          src="/images/photos/users.png"
          width={isDesktop ? 118 : 72}
          height={isDesktop ? 40 : 24}
          alt="RatePunk users"
        />
        <Text tagName="p" variant="body-7" fontWeight={500} color="white">
          150,000+ users worldwide
        </Text>
      </Flex>
    </Box>
  )
}

export default Homepage
